import React from 'react';

import styles from './Divider.Thin.module.scss';

export const DividerThin: React.SFC = () => <hr className={styles.dividerThin} />;
